export default __webpack_public_path__ + "static/media/wi-day-sunny.c23e7855.svg";